import Vue from "vue";
import axios from 'axios';
import store from '../store'
import router from '../router';
import _ from 'lodash'

const customAPI = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  headers: {
    'Accept': 'application/json'
  }
});

let isRefreshing = false;
let isLoginTokenRefreshed = false;
let failedPromiseCollection = [];

const processPromiseCollection = (error, token = null) => {
  failedPromiseCollection.forEach((promise) => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve(token);
    }
  });
  failedPromiseCollection = [];
};

//---request interceptor
customAPI.interceptors.request.use(function (config) {
  let token = localStorage.getItem('access_token')
  if (token && !config.headers.Authorization) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  config.headers['Content-Type'] = 'application/json';

  return config;
}, function (error) {
  return Promise.reject(error);
});

//---response interceptor
customAPI.interceptors.response.use(function (response) {
  return response;
}, function (error) {

  if (!isLoginTokenRefreshed) {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest.retry) {

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedPromiseCollection.push({resolve, reject});
        }).then(token => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return Vue.axios(originalRequest);
        }).catch(error => error);
      }

      originalRequest.retry = true;
      isRefreshing = true;

      return new Promise((resolve, reject) => {
        let ptf_token =  localStorage.getItem('ptf_token')

        if (ptf_token) {
          customAPI.post('/auth/login', { token: ptf_token})
            .then(response => {
              store.commit('AUTH/AUTH_LOGIN', response.data.access_token);
              isLoginTokenRefreshed = true;

              store.dispatch('AUTH/AUTH_GET_USER').then(()=>{
                originalRequest.headers.Authorization = 'Bearer ' + response.data.access_token;
                processPromiseCollection(null, response.data.access_token);
                resolve(Vue.axios(originalRequest));
              }).catch(()=>{
                processPromiseCollection(error, null);
                reject(error);
                isRefreshing = false;
              });
            })
            .catch(error => {
              if (error.response.status === 418) {
                store.commit('AUTH/AUTH_PTF_TOKEN_SET', null);
                store.commit('AUTH/AUTH_LOGOUT');
                store.commit('APP/APP_POPUP_OPEN', 'popupLogin');
              } else {
                store.commit('AUTH/AUTH_LOGOUT');
                router.push({ name: 'home' });
              }
              processPromiseCollection(error, null);
              reject(error);
            })
            .finally(() => {
              isRefreshing = false;
            });
        } else {
          store.commit('AUTH/AUTH_PTF_TOKEN_SET', null);
          store.commit('AUTH/AUTH_LOGOUT');
          store.commit('APP/APP_POPUP_OPEN', 'popupLogin');
          processPromiseCollection(error, null);
          reject(error);
          isRefreshing = false;
        }
      });
    } else if (error.response.status !== 418) {
      Vue.$snotify.error(error);
    }
  }
  return Promise.reject(error);
});
Vue.axios = customAPI;